import KnowledgeIcon from "../../../assets/challenge_icons/knowledge.png";
import TalentIcon from "../../../assets/challenge_icons/talent.png";
import CreativityIcon from "../../../assets/challenge_icons/creativity.png";

export default function QuestionTextHeader({
    challengeType,
    rightHeaderContent
}) {
    const challengeIcons = {
        desafioConocimiento: KnowledgeIcon,
        desafioTalento: TalentIcon,
        desafioCreativo: CreativityIcon
    };

    return (
        <div className="base-container-width">
            <div className="flex justify-center gap-2">
                {challengeIcons[challengeType] &&
                    <div className="bouncing">
                        <img src={challengeIcons[challengeType]} alt="challenge_icon" className="challenge-icon" />
                    </div>
                }
            </div>
            <div className="absolute top-0 right-0 z-10">
                {rightHeaderContent}
            </div>
        </div>
    )
}